import { FetchCuratedFolderPageContent } from 'components/Fetch'
import { TIMERANGE_FILTER_DEFAULT } from 'config'
import { CuratedFolder, StatusIdea } from 'interfaces'
import { Fragment, memo, useCallback, useState } from 'react'
import CuratedFolderListView from './CuratedFolderListView'

interface StatusIdeasCategoryListViewProps {
  folder: CuratedFolder
}

export const StatusIdeasCategoryListView = memo(function StatusIdeasCategoryListView(props: StatusIdeasCategoryListViewProps) {
  const [page, setPage] = useState(0)
  const [hasNextPage, setHasNextPage] = useState(true)
  const [items, setItems] = useState<StatusIdea[]>([])
  const [loading, setLoading] = useState(true)

  const onFetched = useCallback((newItems: StatusIdea[]) => {
    setLoading(false)
    if (newItems.length === 0) {
      setHasNextPage(false)
      return
    }
    setItems((prevItems) => [...prevItems, ...newItems])
  }, [])

  const onFailed = useCallback(() => {
    setLoading(false)
  }, [])

  const fetchNextPage = useCallback(() => {
    if (!hasNextPage && !loading) {
      return
    }
    setPage((prevPage) => {
      setLoading(true)
      return prevPage + 1
    })
  }, [hasNextPage, loading])

  return (
    <Fragment>
      <FetchCuratedFolderPageContent
        folder={props.folder}
        page={page}
        statusesSeed="category-list"
        range={TIMERANGE_FILTER_DEFAULT}
        onFetched={onFetched}
        onFailed={onFailed}
      />
      <CuratedFolderListView
        stream={props.folder as any}
        items={items}
        loading={loading}
        onScrollLimit={fetchNextPage}
      />
    </Fragment>
  )
})

export default StatusIdeasCategoryListView
